import script from "./fyllrReportView.vue?vue&type=script&setup=true&lang=js"
export * from "./fyllrReportView.vue?vue&type=script&setup=true&lang=js"

import "./fyllrReportView.vue?vue&type=style&index=0&id=32f696a5&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f696a5"]])

export default __exports__